<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <crud-list
          :fetch-data="fetchInstitutions"
          :create-allowed="isPowerUserOrAdministrator"
          title="Institutions"
          @create="create"
          @row-clicked="rowClicked"
        >
          <el-table-column label="Nom" min-width="20" property="name" />
          <el-table-column label="Acronyme" min-width="20">
            <div slot-scope="slotScope">
              {{ slotScope.row.acronym ? slotScope.row.acronym : '-' }}
            </div>
          </el-table-column>
        </crud-list>
      </div>
    </div>
  </div>
</template>

<script>
import { isPowerUserOrAdministrator } from '@/services/AuthService';
import CrudList from './CrudList.vue';

export default {
  components: {
    CrudList,
  },
  data() {
    return {
      searchText: '',
    };
  },
  computed: {
    isPowerUserOrAdministrator,
  },
  created() {
    if (this.$route.params && this.$route.params.searchText) {
      this.searchText = this.$route.params.searchText;
    }
  },
  methods: {
    rowClicked(row) {
      this.$router.push({
        name: 'InstitutionDetails',
        params: { id: row.id, newInstitutionCreation: false },
      });
    },
    fetchInstitutions(pageNumber, pageSize, searchText) {
      let url = process.env.VUE_APP_ANNUAIRE_API_URL;

      // If a searchText is defined within the component (coming from the route parameter in created
      // method), fetch institutions corresponding to that text
      if (this.searchText) {
        // eslint-disable-next-line no-param-reassign
        searchText = this.searchText;
        // Reset component's searchText
        this.searchText = '';
      }

      if (searchText) {
        url += `/search/institutions?searchTerm=${searchText}&page=${pageNumber -
          1}&size=${pageSize}`;
      } else {
        url += `/institutionEntities?projection=institutionListDTO&sort=name&page=${pageNumber -
          1}&size=${pageSize}`;
      }

      return this.$http.get(url).then(response => ({
        records: response.data._embedded.institutionEntities
          ? response.data._embedded.institutionEntities
          : [],
        page: response.data.page,
      }));
    },
    create() {
      this.$router.push({
        name: 'InstitutionDetails',
        params: { id: 0, newInstitutionCreation: true },
      });
    },
  },
};
</script>

<style scoped></style>
